(() => {
  const TEXT_MAP = new Map([
    ['availability', 'НАЛИЧНОСТ'],
    ['in stock', 'В наличност'],
    ['out of stock', 'Изчерпан'],
    ['price', 'ЦЕНА'],
    ['to', 'до'],
  ]);

  const translateTextNode = (node) => {
    if (!node) return;
    const key = String(node.textContent || '').trim().toLowerCase();
    const translated = TEXT_MAP.get(key);
    if (translated) node.textContent = translated;
  };

  const translate = (root = document) => {
    root.querySelectorAll?.('.facets__label, .checkbox__label-text, .price-facet__separator').forEach(translateTextNode);

    root.querySelectorAll?.('.checkbox__input[data-label]').forEach((input) => {
      const key = String(input.dataset.label || '').trim().toLowerCase();
      const translated = TEXT_MAP.get(key);
      if (translated) input.dataset.label = translated;
    });
  };

  let scheduled = false;
  const scheduleTranslate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      translate(document);
    });
  };

  document.addEventListener('DOMContentLoaded', scheduleTranslate, { once: true });
  document.addEventListener('shopify:section:load', scheduleTranslate);

  const observer = new MutationObserver(scheduleTranslate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
